// Generated by `bun run i18n:check` from the en locale resources. Do not edit.

export const TRANSLATION_KEYS = [
  'admin.apply.attentionLede',
  'admin.apply.attentionTitle',
  'admin.apply.backToCheck',
  'admin.apply.doneTitle',
  'admin.apply.embedded',
  'admin.apply.progress',
  'admin.apply.retry',
  'admin.apply.retryAll',
  'admin.apply.runningTitle',
  'admin.apply.stoppedLede',
  'admin.apply.stoppedTitle',
  'admin.apply.without',
  'admin.apply.withoutAll',
  'admin.bar.add',
  'admin.bar.apply',
  'admin.bar.back',
  'admin.bar.backToFile',
  'admin.bar.backToQuestions',
  'admin.bar.fixFirst',
  'admin.bar.next',
  'admin.bar.nothing',
  'admin.bar.remove',
  'admin.bar.same',
  'admin.bar.start',
  'admin.bar.toCollections',
  'admin.bar.toReview',
  'admin.bar.update',
  'admin.changes.collectionDelete',
  'admin.changes.collectionSave',
  'admin.changes.delete',
  'admin.changes.empty',
  'admin.changes.entry',
  'admin.changes.loading',
  'admin.changes.save',
  'admin.changes.tacticDelete',
  'admin.changes.tacticSave',
  'admin.changes.title',
  'admin.collections.adds',
  'admin.collections.choice.add',
  'admin.collections.choice.replace',
  'admin.collections.choice.skip',
  'admin.collections.deleteConfirm',
  'admin.collections.dropped',
  'admin.collections.droppedTotal',
  'admin.collections.invalid',
  'admin.collections.lede',
  'admin.collections.members',
  'admin.collections.nameTaken',
  'admin.collections.nothingToDo',
  'admin.collections.removes',
  'admin.collections.renamed',
  'admin.collections.save',
  'admin.collections.saved',
  'admin.collections.siteEmpty',
  'admin.collections.siteTitle',
  'admin.collections.status.new',
  'admin.collections.status.unchanged',
  'admin.collections.status.update',
  'admin.collections.title',
  'admin.contributors.empty',
  'admin.contributors.lede',
  'admin.contributors.loading',
  'admin.contributors.title',
  'admin.contributors.total',
  'admin.current.cancel',
  'admin.current.confirm',
  'admin.current.delete',
  'admin.current.deleteConfirm',
  'admin.current.empty',
  'admin.current.loading',
  'admin.current.title',
  'admin.edit.author',
  'admin.edit.authorUrl',
  'admin.edit.callout',
  'admin.edit.notes',
  'admin.edit.tags',
  'admin.edit.title',
  'admin.error.bodyTooLarge',
  'admin.error.collectionNameTaken',
  'admin.error.forbidden',
  'admin.error.invalidCollection',
  'admin.error.invalidDecisions',
  'admin.error.invalidFile',
  'admin.error.invalidInvite',
  'admin.error.invalidJson',
  'admin.error.invalidLineup',
  'admin.error.invalidMap',
  'admin.error.invalidPhoto',
  'admin.error.invalidRequest',
  'admin.error.invalidTactic',
  'admin.error.lastOwner',
  'admin.error.nameRequired',
  'admin.error.network',
  'admin.error.notFound',
  'admin.error.retry',
  'admin.error.tacticChanged',
  'admin.error.title',
  'admin.error.tooManyPhotos',
  'admin.error.unauthorized',
  'admin.field.aim',
  'admin.field.author',
  'admin.field.callout',
  'admin.field.command',
  'admin.field.groups',
  'admin.field.kind',
  'admin.field.landing',
  'admin.field.landingCommand',
  'admin.field.mediaUrl',
  'admin.field.mouseButtons',
  'admin.field.movement',
  'admin.field.movementInstructions',
  'admin.field.notes',
  'admin.field.origin',
  'admin.field.photos',
  'admin.field.side',
  'admin.field.tags',
  'admin.field.throwType',
  'admin.field.title',
  'admin.field.waypoints',
  'admin.file.choose',
  'admin.file.drop',
  'admin.file.found',
  'admin.file.hint',
  'admin.file.invalidJson',
  'admin.file.invalidSchema',
  'admin.file.or',
  'admin.file.otherMaps',
  'admin.file.replace',
  'admin.file.summary',
  'admin.file.title',
  'admin.file.unsupportedVersion',
  'admin.fix.allGood',
  'admin.fix.dropPhoto',
  'admin.fix.fixed',
  'admin.fix.invalid',
  'admin.fix.invalidHow',
  'admin.fix.landingOff',
  'admin.fix.landingOffHow',
  'admin.fix.originOff',
  'admin.fix.originOffHow',
  'admin.fix.photoHttp',
  'admin.fix.photoHttpHow',
  'admin.fix.place',
  'admin.fix.titleBlank',
  'admin.fix.titleBlankHow',
  'admin.fix.titleLabel',
  'admin.fix.titleLong',
  'admin.fix.titleLongHow',
  'admin.fix.titlePlaceholder',
  'admin.fix.waiting',
  'admin.fix.wrongMap',
  'admin.fix.wrongMapHow',
  'admin.invite.brand',
  'admin.invite.canAdd',
  'admin.invite.canFix',
  'admin.invite.canInvite',
  'admin.invite.canShare',
  'admin.invite.checking',
  'admin.invite.device',
  'admin.invite.deviceHeading',
  'admin.invite.exampleA',
  'admin.invite.exampleB',
  'admin.invite.examples',
  'admin.invite.fine',
  'admin.invite.heading',
  'admin.invite.name',
  'admin.invite.nameHint',
  'admin.invite.namePlaceholder',
  'admin.invite.pill',
  'admin.invite.pillAnon',
  'admin.invite.role',
  'admin.invite.signingIn',
  'admin.invite.submit',
  'admin.linkFailure.badRedirect',
  'admin.linkFailure.httpStatus',
  'admin.linkFailure.invalidUrl',
  'admin.linkFailure.missing',
  'admin.linkFailure.network',
  'admin.linkFailure.notAnImage',
  'admin.linkFailure.notHttps',
  'admin.linkFailure.other',
  'admin.linkFailure.timeout',
  'admin.linkFailure.tooLarge',
  'admin.linkFailure.tooManyRedirects',
  'admin.map.gap',
  'admin.map.label',
  'admin.map.legendDrag',
  'admin.map.legendFile',
  'admin.map.legendSite',
  'admin.map.moveLanding',
  'admin.map.moveOrigin',
  'admin.map.note',
  'admin.map.placeLanding',
  'admin.map.placeOrigin',
  'admin.merge.allFile',
  'admin.merge.allStored',
  'admin.merge.empty',
  'admin.merge.field',
  'admin.merge.hint',
  'admin.merge.inFile',
  'admin.merge.onSite',
  'admin.merge.title',
  'admin.nav.account',
  'admin.nav.home',
  'admin.nav.label',
  'admin.onSite.cancel',
  'admin.onSite.save',
  'admin.outcome.add',
  'admin.outcome.addSecond',
  'admin.outcome.fix',
  'admin.outcome.merge',
  'admin.outcome.same',
  'admin.outcome.skip',
  'admin.outcome.update',
  'admin.overview.actions.add.count',
  'admin.overview.actions.add.text',
  'admin.overview.actions.add.title',
  'admin.overview.actions.collections.count',
  'admin.overview.actions.collections.text',
  'admin.overview.actions.collections.title',
  'admin.overview.actions.onSite.count',
  'admin.overview.actions.onSite.text',
  'admin.overview.actions.onSite.title',
  'admin.overview.actions.tactics.count',
  'admin.overview.actions.tactics.text',
  'admin.overview.actions.tactics.title',
  'admin.overview.add',
  'admin.overview.addSteam',
  'admin.overview.firstAction',
  'admin.overview.firstLede',
  'admin.overview.firstTitle',
  'admin.overview.hello',
  'admin.overview.heroLede',
  'admin.overview.loading',
  'admin.overview.maps.lede',
  'admin.overview.maps.nothing',
  'admin.overview.maps.open',
  'admin.overview.maps.title',
  'admin.overview.newTactic',
  'admin.overview.people.count',
  'admin.overview.people.devices',
  'admin.overview.people.manage',
  'admin.overview.people.role',
  'admin.overview.people.title',
  'admin.overview.recent.all',
  'admin.overview.recent.collectionAdd',
  'admin.overview.recent.collectionDelete',
  'admin.overview.recent.collectionUpdate',
  'admin.overview.recent.empty',
  'admin.overview.recent.lineupAdd',
  'admin.overview.recent.lineupDelete',
  'admin.overview.recent.lineupUpdate',
  'admin.overview.recent.tacticAdd',
  'admin.overview.recent.tacticDelete',
  'admin.overview.recent.tacticUpdate',
  'admin.overview.recent.title',
  'admin.overview.recent.untitled',
  'admin.overview.top.all',
  'admin.overview.top.empty',
  'admin.overview.top.title',
  'admin.overview.totals.collections',
  'admin.overview.totals.lineups',
  'admin.overview.totals.maps',
  'admin.overview.totals.tactics',
  'admin.overview.totals.title',
  'admin.overview.totals.week',
  'admin.overview.yourLast',
  'admin.overview.yourLastNone',
  'admin.overview.yourLineups',
  'admin.people.addDevice',
  'admin.people.cancel',
  'admin.people.confirm',
  'admin.people.copied',
  'admin.people.copy',
  'admin.people.devices',
  'admin.people.disable',
  'admin.people.disableConfirm',
  'admin.people.disabled',
  'admin.people.inviteNew',
  'admin.people.inviteRole',
  'admin.people.lastSeen',
  'admin.people.linkFor',
  'admin.people.linkNote',
  'admin.people.loading',
  'admin.people.newPerson',
  'admin.people.revoke',
  'admin.people.thisDevice',
  'admin.people.title',
  'admin.people.unknownDevice',
  'admin.photos.both',
  'admin.photos.earlier',
  'admin.photos.file',
  'admin.photos.hint',
  'admin.photos.later',
  'admin.photos.orderLabel',
  'admin.photos.remain',
  'admin.photos.site',
  'admin.photos.title',
  'admin.photos.unavailable',
  'admin.preview.empty',
  'admin.preview.loading',
  'admin.q.clash',
  'admin.q.count',
  'admin.q.dupAdd',
  'admin.q.dupAddHint',
  'admin.q.dupLede',
  'admin.q.dupMerge',
  'admin.q.dupMergeHint',
  'admin.q.dupSkip',
  'admin.q.dupSkipHint',
  'admin.q.dupTitle',
  'admin.q.errAdd',
  'admin.q.errAddBlocked',
  'admin.q.errAddHint',
  'admin.q.errLede',
  'admin.q.errLedeFixed',
  'admin.q.errSkip',
  'admin.q.errSkipHint',
  'admin.q.errTitle',
  'admin.q.errTitleFixed',
  'admin.q.errTitleUntitled',
  'admin.q.errTitleUntitledFixed',
  'admin.q.optionsLabel',
  'admin.q.pillDuplicate',
  'admin.q.pillFix',
  'admin.q.pillFixed',
  'admin.q.pillUpdate',
  'admin.q.updateBoth',
  'admin.q.updateBothHint',
  'admin.q.updateFile',
  'admin.q.updateFileHint',
  'admin.q.updateLede',
  'admin.q.updateMerge',
  'admin.q.updateMergeHint',
  'admin.q.updateStored',
  'admin.q.updateStoredHint',
  'admin.q.updateTitle',
  'admin.result.again',
  'admin.result.copied',
  'admin.result.parts',
  'admin.result.removed',
  'admin.result.revision',
  'admin.result.saved',
  'admin.result.skipped',
  'admin.result.uploaded',
  'admin.review.lede',
  'admin.review.title',
  'admin.role.editor',
  'admin.role.owner',
  'admin.row.clash',
  'admin.row.drop',
  'admin.row.edit',
  'admin.row.editDone',
  'admin.row.photos',
  'admin.row.restore',
  'admin.row.untitled',
  'admin.server.keep',
  'admin.server.merged',
  'admin.server.remove',
  'admin.server.removing',
  'admin.server.stays',
  'admin.server.title',
  'admin.signOut',
  'admin.signedIn',
  'admin.signedOut.body',
  'admin.signedOut.owner',
  'admin.signedOut.title',
  'admin.steam.add',
  'admin.steam.cancel',
  'admin.steam.edit',
  'admin.steam.hint',
  'admin.steam.invalid',
  'admin.steam.label',
  'admin.steam.none',
  'admin.steam.optional',
  'admin.steam.placeholder',
  'admin.steam.remove',
  'admin.steam.save',
  'admin.steam.yours',
  'admin.step.decide',
  'admin.step.done',
  'admin.step.file',
  'admin.step.review',
  'admin.summary.duplicate',
  'admin.summary.invalid',
  'admin.summary.new',
  'admin.summary.same',
  'admin.summary.update',
  'admin.tabs.contributors',
  'admin.tabs.history',
  'admin.tabs.import',
  'admin.tabs.onSite',
  'admin.tabs.overview',
  'admin.tabs.people',
  'admin.tabs.tactics',
  'admin.tactics.choice.add',
  'admin.tactics.choice.replace',
  'admin.tactics.choice.skip',
  'admin.tactics.comparing',
  'admin.tactics.create',
  'admin.tactics.deleteConfirm',
  'admin.tactics.discardConfirm',
  'admin.tactics.drop',
  'admin.tactics.edit',
  'admin.tactics.field.author',
  'admin.tactics.field.content',
  'admin.tactics.field.description',
  'admin.tactics.field.map',
  'admin.tactics.field.plans',
  'admin.tactics.field.rounds',
  'admin.tactics.field.side',
  'admin.tactics.field.steps',
  'admin.tactics.field.title',
  'admin.tactics.field.weapons',
  'admin.tactics.fileInvalid',
  'admin.tactics.fileSummary',
  'admin.tactics.hint',
  'admin.tactics.nothingToDo',
  'admin.tactics.problem.invalid_map',
  'admin.tactics.problem.invalid_tactic',
  'admin.tactics.problem.title_blank',
  'admin.tactics.problem.title_too_long',
  'admin.tactics.problem.too_large',
  'admin.tactics.reload',
  'admin.tactics.save',
  'admin.tactics.saved',
  'admin.tactics.sideLabel',
  'admin.tactics.siteEmpty',
  'admin.tactics.siteTitle',
  'admin.tactics.skipped',
  'admin.tactics.stale',
  'admin.tactics.status.new',
  'admin.tactics.status.unchanged',
  'admin.tactics.status.update',
  'admin.tactics.summary',
  'admin.tactics.title',
  'admin.telegram.add',
  'admin.telegram.cancel',
  'admin.telegram.edit',
  'admin.telegram.hint',
  'admin.telegram.invalid',
  'admin.telegram.label',
  'admin.telegram.link',
  'admin.telegram.none',
  'admin.telegram.optional',
  'admin.telegram.placeholder',
  'admin.telegram.remove',
  'admin.telegram.save',
  'admin.telegram.yours',
  'admin.throw.crouch',
  'admin.throw.jump',
  'admin.throw.run',
  'admin.throw.stand',
  'admin.throw.unknown',
  'admin.title',
  'common.help',
  'common.settings',
  'common.soon',
  'controls.matchTime',
  'controls.pause',
  'controls.play',
  'controls.speed',
  'controls.speedValue',
  'controls.stepBack',
  'controls.stepForward',
  'errors.malformed.hint',
  'errors.malformed.title',
  'errors.notADemo.hint',
  'errors.notADemo.title',
  'errors.povDemo.hint',
  'errors.povDemo.title',
  'errors.truncated.hint',
  'errors.truncated.title',
  'errors.unsupportedContainer.hint',
  'errors.unsupportedContainer.title',
  'errors.unsupportedVersion.hint',
  'errors.unsupportedVersion.title',
  'events.defuse.aborted',
  'events.defuse.completed',
  'events.defuse.interrupted',
  'events.grenade',
  'events.kill.byPlayer',
  'events.kill.byWorld',
  'events.kill.headshot',
  'events.kill.throughSmoke',
  'events.kill.wallbang',
  'events.plant',
  'events.plantAt',
  'filters.axis.kills',
  'filters.axis.label',
  'filters.axis.noSubject',
  'filters.axis.objectives',
  'filters.axis.subject',
  'filters.axis.utility',
  'help.about.body',
  'help.about.title',
  'help.dismiss',
  'help.keyboard.note',
  'help.keyboard.title',
  'help.keys.escape',
  'help.keys.space',
  'help.legend.audible',
  'help.legend.blinded',
  'help.legend.dead',
  'help.legend.decoy',
  'help.legend.fire',
  'help.legend.firing',
  'help.legend.flash',
  'help.legend.he',
  'help.legend.hit',
  'help.legend.kill',
  'help.legend.leader',
  'help.legend.objective',
  'help.legend.player',
  'help.legend.selected',
  'help.legend.smoke',
  'help.legend.title',
  'help.legend.trajectory',
  'help.legend.walking',
  'help.legend.weapon',
  'help.shortcut.clearSelection',
  'help.shortcut.coachMode',
  'help.shortcut.fullscreen',
  'help.shortcut.help',
  'help.shortcut.matchOverlay',
  'help.shortcut.nextRound',
  'help.shortcut.nextView',
  'help.shortcut.playPause',
  'help.shortcut.previousRound',
  'help.shortcut.seekBack',
  'help.shortcut.seekForward',
  'help.shortcut.selectCtRow',
  'help.shortcut.selectTRow',
  'help.shortcut.stepBack',
  'help.shortcut.stepForward',
  'help.shortcut.zoomIn',
  'help.shortcut.zoomOut',
  'help.title',
  'library.cache.cancel',
  'library.cache.downloadPercent',
  'library.cache.downloading',
  'library.cache.restoring',
  'library.cache.storing',
  'library.cache.unavailable',
  'library.card.overtime',
  'library.card.overtimeMeta',
  'library.card.sample',
  'library.card.when',
  'library.counts.players',
  'library.dialog.close',
  'library.dialog.label',
  'library.dialog.loading',
  'library.dialog.open',
  'library.dialog.plate',
  'library.dialog.round',
  'library.dialog.rounds',
  'library.grid.allMaps',
  'library.grid.lede',
  'library.grid.mapFilter',
  'library.grid.newestFirst',
  'library.grid.noMatch',
  'library.grid.oldestFirst',
  'library.grid.openFormats',
  'library.grid.openTitle',
  'library.grid.persistence',
  'library.grid.searchLabel',
  'library.grid.searchPlaceholder',
  'library.grid.sort',
  'library.grid.title',
  'library.home.customize.add',
  'library.home.customize.addAction',
  'library.home.customize.done',
  'library.home.customize.gallery',
  'library.home.customize.handle',
  'library.home.customize.hint',
  'library.home.customize.moved',
  'library.home.customize.needsMatch',
  'library.home.customize.on',
  'library.home.customize.open',
  'library.home.customize.openLabel',
  'library.home.customize.position',
  'library.home.customize.remove',
  'library.home.customize.removeShort',
  'library.home.customize.reset',
  'library.home.customize.size',
  'library.home.customize.sizeName.L',
  'library.home.customize.sizeName.M',
  'library.home.customize.sizeName.S',
  'library.home.customize.sizeName.XL',
  'library.home.customize.sizeOption',
  'library.home.customize.title',
  'library.home.footer',
  'library.home.hero.continue',
  'library.home.hero.formats',
  'library.home.hero.momentClutch',
  'library.home.hero.momentMulti',
  'library.home.hero.momentRound',
  'library.home.hero.moments',
  'library.home.hero.momentsMore',
  'library.home.hero.openYours',
  'library.home.hero.readAt',
  'library.home.hero.resume',
  'library.home.hero.review',
  'library.home.hero.reviewSample',
  'library.home.hero.sample',
  'library.home.hero.score',
  'library.home.hero.scoreNote',
  'library.home.hero.stopped',
  'library.home.subtitle',
  'library.home.subtitleFirst',
  'library.home.title',
  'library.home.titleFirst',
  'library.home.widget.coach.blurb',
  'library.home.widget.coach.emptyHint',
  'library.home.widget.coach.emptyTitle',
  'library.home.widget.coach.eyebrow',
  'library.home.widget.coach.meta',
  'library.home.widget.coach.open',
  'library.home.widget.coach.round',
  'library.home.widget.coach.title',
  'library.home.widget.economy.blurb',
  'library.home.widget.economy.title',
  'library.home.widget.hero.blurb',
  'library.home.widget.hero.title',
  'library.home.widget.keys.blurb',
  'library.home.widget.keys.title',
  'library.home.widget.lineup.another',
  'library.home.widget.lineup.blurb',
  'library.home.widget.lineup.emptyHint',
  'library.home.widget.lineup.emptyTitle',
  'library.home.widget.lineup.eyebrow',
  'library.home.widget.lineup.meta',
  'library.home.widget.lineup.practise',
  'library.home.widget.lineup.save',
  'library.home.widget.lineup.title',
  'library.home.widget.open.action',
  'library.home.widget.open.blurb',
  'library.home.widget.open.hint',
  'library.home.widget.open.title',
  'library.home.widget.recent.blurb',
  'library.home.widget.recent.library',
  'library.home.widget.recent.matchMeta',
  'library.home.widget.recent.matchTitle',
  'library.home.widget.recent.samples',
  'library.home.widget.recent.tacticMeta',
  'library.home.widget.recent.title',
  'library.home.widget.refs.blurb',
  'library.home.widget.refs.title',
  'library.home.widget.soon.blurb',
  'library.home.widget.soon.title',
  'library.home.widget.stats.adr',
  'library.home.widget.stats.blurb',
  'library.home.widget.stats.eyebrow',
  'library.home.widget.stats.eyebrowKnown',
  'library.home.widget.stats.find',
  'library.home.widget.stats.kd',
  'library.home.widget.stats.label',
  'library.home.widget.stats.notYou',
  'library.home.widget.stats.noteAbsent',
  'library.home.widget.stats.noteFormat',
  'library.home.widget.stats.noteHint',
  'library.home.widget.stats.noteVanity',
  'library.home.widget.stats.open',
  'library.home.widget.stats.prompt',
  'library.home.widget.stats.rank',
  'library.home.widget.stats.team',
  'library.home.widget.stats.title',
  'library.home.widget.storage.blurb',
  'library.home.widget.storage.status',
  'library.home.widget.storage.title',
  'library.home.widget.tactics.blurb',
  'library.home.widget.tactics.draw',
  'library.home.widget.tactics.emptyHint',
  'library.home.widget.tactics.emptyTitle',
  'library.home.widget.tactics.eyebrow',
  'library.home.widget.tactics.eyebrowEmpty',
  'library.home.widget.tactics.meta',
  'library.home.widget.tactics.open',
  'library.home.widget.tactics.title',
  'library.lineups.add',
  'library.lineups.addBounce',
  'library.lineups.addFlow.aim',
  'library.lineups.addFlow.aimPlaceholder',
  'library.lineups.addFlow.bannerLand',
  'library.lineups.addFlow.bannerOrigin',
  'library.lineups.addFlow.kindSide',
  'library.lineups.addFlow.later',
  'library.lineups.addFlow.name',
  'library.lineups.addFlow.photos',
  'library.lineups.addFlow.redo',
  'library.lineups.addFlow.save',
  'library.lineups.addFlow.sideCT',
  'library.lineups.addFlow.sideT',
  'library.lineups.addFlow.step.details.hint',
  'library.lineups.addFlow.step.details.title',
  'library.lineups.addFlow.step.land.hint',
  'library.lineups.addFlow.step.land.title',
  'library.lineups.addFlow.step.origin.hint',
  'library.lineups.addFlow.step.origin.title',
  'library.lineups.addFlow.stepOf',
  'library.lineups.addFlow.throwType',
  'library.lineups.addFlow.title',
  'library.lineups.addFlow.titleAnother',
  'library.lineups.allKinds',
  'library.lineups.allTags',
  'library.lineups.another',
  'library.lineups.bothSides',
  'library.lineups.chip.author',
  'library.lineups.chip.bothSides',
  'library.lineups.chip.side',
  'library.lineups.chip.telegram',
  'library.lineups.chip.telegramLabel',
  'library.lineups.clearSelection',
  'library.lineups.closePanel',
  'library.lineups.collections.actions',
  'library.lineups.collections.add',
  'library.lineups.collections.all',
  'library.lineups.collections.cancel',
  'library.lineups.collections.copy',
  'library.lineups.collections.copyName',
  'library.lineups.collections.create',
  'library.lineups.collections.createWith',
  'library.lineups.collections.delete',
  'library.lineups.collections.deleteConfirm',
  'library.lineups.collections.empty',
  'library.lineups.collections.emptyCollection',
  'library.lineups.collections.emptyCollectionHint',
  'library.lineups.collections.nameLabel',
  'library.lineups.collections.namePlaceholder',
  'library.lineups.collections.nameTaken',
  'library.lineups.collections.nav',
  'library.lineups.collections.new',
  'library.lineups.collections.newCollection',
  'library.lineups.collections.partly',
  'library.lineups.collections.pickerEmpty',
  'library.lineups.collections.pickerHint',
  'library.lineups.collections.pickerTitle',
  'library.lineups.collections.rename',
  'library.lineups.collections.rowAria',
  'library.lineups.collections.save',
  'library.lineups.collections.title',
  'library.lineups.commandLanding',
  'library.lineups.commandOrigin',
  'library.lineups.confirm.delete',
  'library.lineups.confirm.discard',
  'library.lineups.confirm.keepEditing',
  'library.lineups.coordinatesLanding',
  'library.lineups.coordinatesOrigin',
  'library.lineups.coordinatesTitle',
  'library.lineups.copied',
  'library.lineups.copy',
  'library.lineups.copyCommand',
  'library.lineups.copyLandingCommand',
  'library.lineups.create',
  'library.lineups.delete',
  'library.lineups.deleteBounce',
  'library.lineups.deleteConfirm',
  'library.lineups.deleteSelected',
  'library.lineups.deleteSelectedConfirm',
  'library.lineups.edit',
  'library.lineups.editShort',
  'library.lineups.editing.bounces',
  'library.lineups.editing.details',
  'library.lineups.editing.done',
  'library.lineups.editing.hint',
  'library.lineups.editing.sharedLanding',
  'library.lineups.editing.sharedOrigin',
  'library.lineups.editing.title',
  'library.lineups.empty',
  'library.lineups.emptyMap',
  'library.lineups.emptyMapHint',
  'library.lineups.form.addImage',
  'library.lineups.form.authorName',
  'library.lineups.form.authorNamePlaceholder',
  'library.lineups.form.authorTelegram',
  'library.lineups.form.authorTelegramPlaceholder',
  'library.lineups.form.authorUrl',
  'library.lineups.form.back',
  'library.lineups.form.callout',
  'library.lineups.form.calloutPlaceholder',
  'library.lineups.form.cancel',
  'library.lineups.form.catboxModal.description',
  'library.lineups.form.catboxModal.dontShowAgain',
  'library.lineups.form.catboxModal.proceed',
  'library.lineups.form.catboxModal.title',
  'library.lineups.form.choosePhotos',
  'library.lineups.form.clearCallout',
  'library.lineups.form.close',
  'library.lineups.form.closePhoto',
  'library.lineups.form.command',
  'library.lineups.form.discardConfirm',
  'library.lineups.form.downloadWebp',
  'library.lineups.form.dragToReorder',
  'library.lineups.form.dropPhotos',
  'library.lineups.form.imageUrls',
  'library.lineups.form.kind',
  'library.lineups.form.landing',
  'library.lineups.form.map',
  'library.lineups.form.mapCoordinatesNote',
  'library.lineups.form.mediaUrl',
  'library.lineups.form.metadata',
  'library.lineups.form.mouse.left',
  'library.lineups.form.mouse.right',
  'library.lineups.form.mouseButtons',
  'library.lineups.form.moveDown',
  'library.lineups.form.moveUp',
  'library.lineups.form.movementInstructions',
  'library.lineups.form.movementInstructionsPlaceholder',
  'library.lineups.form.movementKeys',
  'library.lineups.form.notes',
  'library.lineups.form.notesPlaceholder',
  'library.lineups.form.optional',
  'library.lineups.form.origin',
  'library.lineups.form.photoCaption',
  'library.lineups.form.photoCaptionPlaceholder',
  'library.lineups.form.pitch',
  'library.lineups.form.removeImage',
  'library.lineups.form.save',
  'library.lineups.form.side',
  'library.lineups.form.storedOnDevice',
  'library.lineups.form.suggestedCallouts',
  'library.lineups.form.tags',
  'library.lineups.form.throwType',
  'library.lineups.form.title',
  'library.lineups.form.titlePlaceholder',
  'library.lineups.form.uploadManual',
  'library.lineups.form.uploadToCatbox',
  'library.lineups.form.validation.authorNameRequired',
  'library.lineups.form.validation.authorTelegramInvalid',
  'library.lineups.form.validation.authorUrlInvalid',
  'library.lineups.form.validation.coordinatesRequired',
  'library.lineups.form.validation.imageLinkPending',
  'library.lineups.form.validation.imageProcessingFailed',
  'library.lineups.form.validation.mediaUrlInvalid',
  'library.lineups.form.validation.saveFailed',
  'library.lineups.form.validation.titleRequired',
  'library.lineups.form.viewPhoto',
  'library.lineups.form.yaw',
  'library.lineups.fromDemoNotice',
  'library.lineups.howTo.aim',
  'library.lineups.howTo.console',
  'library.lineups.howTo.noAim',
  'library.lineups.howTo.noCommand',
  'library.lineups.howTo.stand',
  'library.lineups.howTo.throw',
  'library.lineups.howTo.title',
  'library.lineups.importCollections',
  'library.lineups.importError',
  'library.lineups.importSuccess',
  'library.lineups.intro.byHand',
  'library.lineups.intro.fromMatch',
  'library.lineups.intro.lead',
  'library.lineups.intro.onThisMap',
  'library.lineups.intro.ownTitle',
  'library.lineups.intro.title',
  'library.lineups.keys.jump',
  'library.lineups.listTitle',
  'library.lineups.map',
  'library.lineups.media',
  'library.lineups.mergeLandings',
  'library.lineups.mergeOrigins',
  'library.lineups.mergeThrowSpots',
  'library.lineups.mouseShort.left',
  'library.lineups.mouseShort.right',
  'library.lineups.nextPhoto',
  'library.lineups.note.builtIn',
  'library.lineups.note.mine',
  'library.lineups.originAria',
  'library.lineups.originMeta',
  'library.lineups.origins',
  'library.lineups.originsHint',
  'library.lineups.panel',
  'library.lineups.peek.noShot',
  'library.lineups.peek.open',
  'library.lineups.peek.shot',
  'library.lineups.position.addShot',
  'library.lineups.position.fromTo',
  'library.lineups.position.keys',
  'library.lineups.position.next',
  'library.lineups.position.noShots',
  'library.lineups.position.of',
  'library.lineups.position.previous',
  'library.lineups.position.shot',
  'library.lineups.position.shotNumber',
  'library.lineups.position.zoomHint',
  'library.lineups.position.zoomIn',
  'library.lineups.position.zoomLevel',
  'library.lineups.position.zoomOut',
  'library.lineups.position.zoomReset',
  'library.lineups.positions',
  'library.lineups.previousPhoto',
  'library.lineups.search',
  'library.lineups.searchHint',
  'library.lineups.select',
  'library.lineups.selectDone',
  'library.lineups.selectLineup',
  'library.lineups.selectedBounce',
  'library.lineups.selectedCount',
  'library.lineups.selectedLanding',
  'library.lineups.selectedOrigin',
  'library.lineups.side',
  'library.lineups.sidebar',
  'library.lineups.source.builtIn',
  'library.lineups.source.match',
  'library.lineups.source.mine',
  'library.lineups.stackAria',
  'library.lineups.stackTitle',
  'library.lineups.tagFilter',
  'library.lineups.tags.meta',
  'library.lineups.tags.old',
  'library.lineups.targetAria',
  'library.lineups.targetMeta',
  'library.lineups.title',
  'library.lineups.transfer.body',
  'library.lineups.transfer.builtIn',
  'library.lineups.transfer.import',
  'library.lineups.transfer.importHint',
  'library.lineups.transfer.open',
  'library.lineups.transfer.save',
  'library.lineups.transfer.saveCollections',
  'library.lineups.transfer.saveCount',
  'library.lineups.transfer.saveNone',
  'library.lineups.transfer.title',
  'library.lineups.unmergeLandings',
  'library.lineups.unmergeOrigins',
  'library.lineups.waypointsSection',
  'library.open.action',
  'library.open.hint',
  'library.open.hintFolder',
  'library.open.invite',
  'library.open.release',
  'library.open.start',
  'library.open.where',
  'library.preview.label',
  'library.preview.liveRound',
  'library.preview.note',
  'library.preview.pause',
  'library.preview.play',
  'library.preview.round',
  'library.preview.seek',
  'library.progress.cancel',
  'library.progress.hiddenTab',
  'library.progress.label',
  'library.progress.percent',
  'library.progress.phase.decompress',
  'library.progress.phase.parse',
  'library.samples.gone.hint',
  'library.samples.gone.title',
  'library.samples.open',
  'library.samples.size',
  'library.samples.teams',
  'library.saved.duration',
  'library.saved.emptyTitle',
  'library.saved.gone.hint',
  'library.saved.gone.title',
  'library.saved.note',
  'library.saved.open',
  'library.saved.remove',
  'library.saved.rounds',
  'library.saved.score',
  'library.saved.size',
  'library.saved.storedAt',
  'library.shell.admin',
  'library.shell.empty',
  'library.shell.home',
  'library.shell.library',
  'library.shell.lineups',
  'library.shell.nav',
  'library.shell.stats',
  'library.shell.tactics',
  'library.shell.tagline',
  'library.shell.tools',
  'library.shell.update.ready',
  'library.shell.update.reload',
  'library.stats.absent.body',
  'library.stats.absent.title',
  'library.stats.empty.body',
  'library.stats.empty.open',
  'library.stats.empty.title',
  'library.stats.eyebrow',
  'library.stats.find',
  'library.stats.footnote',
  'library.stats.found.line',
  'library.stats.found.me',
  'library.stats.found.team',
  'library.stats.found.you',
  'library.stats.hint',
  'library.stats.kpi.adr.label',
  'library.stats.kpi.adr.subRounds',
  'library.stats.kpi.clutch.best',
  'library.stats.kpi.clutch.label',
  'library.stats.kpi.clutch.none',
  'library.stats.kpi.hs.label',
  'library.stats.kpi.hs.sub',
  'library.stats.kpi.kast.label',
  'library.stats.kpi.kast.sub',
  'library.stats.kpi.kd.label',
  'library.stats.kpi.kd.sub',
  'library.stats.kpi.opening.label',
  'library.stats.kpi.opening.sub',
  'library.stats.label',
  'library.stats.loading.progress',
  'library.stats.loading.title',
  'library.stats.maps.all',
  'library.stats.maps.label',
  'library.stats.matches.columns',
  'library.stats.matches.draw',
  'library.stats.matches.drawMark',
  'library.stats.matches.loss',
  'library.stats.matches.lossMark',
  'library.stats.matches.meta',
  'library.stats.matches.phone',
  'library.stats.matches.title',
  'library.stats.matches.win',
  'library.stats.matches.winMark',
  'library.stats.moments.clutch',
  'library.stats.moments.empty',
  'library.stats.moments.multi',
  'library.stats.moments.title',
  'library.stats.noteFormat',
  'library.stats.noteVanity',
  'library.stats.side.note',
  'library.stats.side.record',
  'library.stats.side.title',
  'library.stats.start.body',
  'library.stats.start.title',
  'library.stats.weapons.empty',
  'library.stats.weapons.title',
  'library.storage.eviction',
  'library.storage.free',
  'library.storage.meter',
  'library.storage.of',
  'library.storage.title',
  'library.storage.used',
  'library.tactics.board.branch.condition',
  'library.tactics.board.branch.conditionPlaceholder',
  'library.tactics.board.branch.dies',
  'library.tactics.board.branch.diesCondition',
  'library.tactics.board.branch.diesFirst',
  'library.tactics.board.branch.eyebrow',
  'library.tactics.board.branch.fromStep',
  'library.tactics.board.branch.fromStepTip',
  'library.tactics.board.branch.root',
  'library.tactics.board.branch.sharedNote',
  'library.tactics.board.branch.sharedStep',
  'library.tactics.board.branch.unnamed',
  'library.tactics.board.enemy.assumption',
  'library.tactics.board.enemy.empty',
  'library.tactics.board.enemy.kill',
  'library.tactics.board.enemy.killed',
  'library.tactics.board.enemy.nobody',
  'library.tactics.board.enemy.note',
  'library.tactics.board.enemy.notePlaceholder',
  'library.tactics.board.enemy.pick',
  'library.tactics.board.enemy.pickPlayer',
  'library.tactics.board.enemy.remove',
  'library.tactics.board.enemy.role',
  'library.tactics.board.enemy.roles.anchor',
  'library.tactics.board.enemy.roles.awp',
  'library.tactics.board.enemy.roles.lurker',
  'library.tactics.board.enemy.roles.rotator',
  'library.tactics.board.enemy.section',
  'library.tactics.board.enemy.taker',
  'library.tactics.board.enemy.title',
  'library.tactics.board.enemy.tool',
  'library.tactics.board.enemy.toolTip',
  'library.tactics.board.floors.label',
  'library.tactics.board.floors.lower',
  'library.tactics.board.floors.main',
  'library.tactics.board.floors.tip',
  'library.tactics.board.floors.underpass',
  'library.tactics.board.floors.upper',
  'library.tactics.board.header.redo',
  'library.tactics.board.header.undo',
  'library.tactics.board.hint.dead',
  'library.tactics.board.hint.enemy',
  'library.tactics.board.hint.enemyPicked',
  'library.tactics.board.hint.grenade',
  'library.tactics.board.hint.grenadeNone',
  'library.tactics.board.hint.pen',
  'library.tactics.board.hint.pickPlayer',
  'library.tactics.board.hint.playing',
  'library.tactics.board.hint.route',
  'library.tactics.board.hint.routeBroken',
  'library.tactics.board.hint.select',
  'library.tactics.board.menu.branchHere',
  'library.tactics.board.menu.cancel',
  'library.tactics.board.menu.confirm',
  'library.tactics.board.menu.confirmButton',
  'library.tactics.board.menu.delete',
  'library.tactics.board.menu.label',
  'library.tactics.board.menu.open',
  'library.tactics.board.menu.undoNote',
  'library.tactics.board.player.arrives',
  'library.tactics.board.player.arrivesNow',
  'library.tactics.board.player.delay',
  'library.tactics.board.player.earlier',
  'library.tactics.board.player.isOut',
  'library.tactics.board.player.later',
  'library.tactics.board.player.leaves',
  'library.tactics.board.player.move',
  'library.tactics.board.player.pen',
  'library.tactics.board.player.points',
  'library.tactics.board.player.removePoint',
  'library.tactics.board.player.spawn',
  'library.tactics.board.player.spawnCustom',
  'library.tactics.board.player.spawnSpot',
  'library.tactics.board.player.standStill',
  'library.tactics.board.player.task',
  'library.tactics.board.player.taskPlaceholder',
  'library.tactics.board.player.title',
  'library.tactics.board.player.weapon',
  'library.tactics.board.player.weaponAny',
  'library.tactics.board.roster.buy',
  'library.tactics.board.roster.dead',
  'library.tactics.board.roster.moves',
  'library.tactics.board.roster.player',
  'library.tactics.board.roster.stands',
  'library.tactics.board.roster.title',
  'library.tactics.board.step.add',
  'library.tactics.board.step.afterPrevious',
  'library.tactics.board.step.delete',
  'library.tactics.board.step.deleteFork',
  'library.tactics.board.step.deleteOnly',
  'library.tactics.board.step.earlier',
  'library.tactics.board.step.eyebrow',
  'library.tactics.board.step.idea',
  'library.tactics.board.step.ideaPlaceholder',
  'library.tactics.board.step.later',
  'library.tactics.board.step.name',
  'library.tactics.board.step.namePlaceholder',
  'library.tactics.board.step.pinned',
  'library.tactics.board.step.startMode',
  'library.tactics.board.step.timingAfter',
  'library.tactics.board.step.timingLate',
  'library.tactics.board.step.timingPinned',
  'library.tactics.board.strip.addStepTo',
  'library.tactics.board.strip.branchAfter',
  'library.tactics.board.strip.card',
  'library.tactics.board.strip.label',
  'library.tactics.board.strip.lane',
  'library.tactics.board.strip.laneFrom',
  'library.tactics.board.strip.laneFromOut',
  'library.tactics.board.strip.laneSteps',
  'library.tactics.board.strip.menuHint',
  'library.tactics.board.strip.noIdea',
  'library.tactics.board.strip.unnamed',
  'library.tactics.board.throws.byHand',
  'library.tactics.board.throws.empty',
  'library.tactics.board.throws.from',
  'library.tactics.board.throws.fromEnd',
  'library.tactics.board.throws.fromLineup',
  'library.tactics.board.throws.fromPoint',
  'library.tactics.board.throws.fromStart',
  'library.tactics.board.throws.meta',
  'library.tactics.board.throws.remove',
  'library.tactics.board.throws.title',
  'library.tactics.board.tools.grenade',
  'library.tactics.board.tools.kinds.fire',
  'library.tactics.board.tools.kinds.flash',
  'library.tactics.board.tools.kinds.he',
  'library.tactics.board.tools.kinds.smoke',
  'library.tactics.board.tools.label',
  'library.tactics.board.tools.pen',
  'library.tactics.board.tools.penTip',
  'library.tactics.board.tools.route',
  'library.tactics.board.tools.routeTip',
  'library.tactics.board.tools.select',
  'library.tactics.board.tools.selectTip',
  'library.tactics.board.transport.clock',
  'library.tactics.board.transport.hint',
  'library.tactics.board.transport.label',
  'library.tactics.board.transport.next',
  'library.tactics.board.transport.pause',
  'library.tactics.board.transport.play',
  'library.tactics.board.transport.prev',
  'library.tactics.board.transport.speed',
  'library.tactics.board.transport.speedValue',
  'library.tactics.board.tree.branchDeleteNote',
  'library.tactics.board.tree.cancel',
  'library.tactics.board.tree.close',
  'library.tactics.board.tree.confirm',
  'library.tactics.board.tree.confirmBranch',
  'library.tactics.board.tree.confirmStep',
  'library.tactics.board.tree.deleteBranch',
  'library.tactics.board.tree.deleteStep',
  'library.tactics.board.tree.eyebrowBranch',
  'library.tactics.board.tree.eyebrowRoot',
  'library.tactics.board.tree.fit',
  'library.tactics.board.tree.graph',
  'library.tactics.board.tree.hint',
  'library.tactics.board.tree.noUtility',
  'library.tactics.board.tree.node',
  'library.tactics.board.tree.open',
  'library.tactics.board.tree.openStep',
  'library.tactics.board.tree.openTip',
  'library.tactics.board.tree.rootDeleteNote',
  'library.tactics.board.tree.sharedDelete',
  'library.tactics.board.tree.summary',
  'library.tactics.board.tree.taskNone',
  'library.tactics.board.tree.taskOut',
  'library.tactics.board.tree.tasks',
  'library.tactics.board.tree.title',
  'library.tactics.board.tree.undo',
  'library.tactics.board.tree.undoNote',
  'library.tactics.board.tree.utility',
  'library.tactics.board.tree.utilityRow',
  'library.tactics.board.tree.wheelHint',
  'library.tactics.board.tree.zoomGroup',
  'library.tactics.board.tree.zoomIn',
  'library.tactics.board.tree.zoomLevel',
  'library.tactics.board.tree.zoomOut',
  'library.tactics.editor.description',
  'library.tactics.editor.descriptionPlaceholder',
  'library.tactics.editor.details',
  'library.tactics.editor.detailsHide',
  'library.tactics.editor.exit',
  'library.tactics.editor.map',
  'library.tactics.editor.mapChangeConfirm',
  'library.tactics.editor.rounds',
  'library.tactics.editor.roundsHint',
  'library.tactics.editor.save',
  'library.tactics.editor.saved',
  'library.tactics.editor.side',
  'library.tactics.editor.subtitle',
  'library.tactics.editor.subtitleAny',
  'library.tactics.editor.tacticTitle',
  'library.tactics.editor.title',
  'library.tactics.editor.unsaved',
  'library.tactics.library.allMaps',
  'library.tactics.library.allSides',
  'library.tactics.library.anyRound',
  'library.tactics.library.builtIn',
  'library.tactics.library.buyCost',
  'library.tactics.library.clearFilters',
  'library.tactics.library.copyTitle',
  'library.tactics.library.delete',
  'library.tactics.library.deleteConfirm',
  'library.tactics.library.dismiss',
  'library.tactics.library.duplicate',
  'library.tactics.library.empty',
  'library.tactics.library.emptyHint',
  'library.tactics.library.exportOne',
  'library.tactics.library.importSuccess',
  'library.tactics.library.mapFilter',
  'library.tactics.library.newOnMap',
  'library.tactics.library.newOnMapHint',
  'library.tactics.library.newTactic',
  'library.tactics.library.noMatch',
  'library.tactics.library.noMatchHint',
  'library.tactics.library.openTactic',
  'library.tactics.library.playbookNote',
  'library.tactics.library.playbookTitle',
  'library.tactics.library.preview',
  'library.tactics.library.roundFilter',
  'library.tactics.library.saveToPlaybook',
  'library.tactics.library.savedToPlaybook',
  'library.tactics.library.searchLabel',
  'library.tactics.library.searchPlaceholder',
  'library.tactics.library.sharedBanner',
  'library.tactics.library.sideFilter',
  'library.tactics.library.stepsDuration',
  'library.tactics.library.throws',
  'library.tactics.loadout.cost',
  'library.tactics.loadout.warn.flashLimit',
  'library.tactics.loadout.warn.kindLimit',
  'library.tactics.loadout.warn.totalLimit',
  'library.tactics.pdf.author',
  'library.tactics.pdf.branchOut',
  'library.tactics.pdf.busy',
  'library.tactics.pdf.buysFor',
  'library.tactics.pdf.continued',
  'library.tactics.pdf.download',
  'library.tactics.pdf.droppedBy',
  'library.tactics.pdf.enemyDead',
  'library.tactics.pdf.enemyTakenBy',
  'library.tactics.pdf.failed',
  'library.tactics.pdf.kind',
  'library.tactics.pdf.leaves',
  'library.tactics.pdf.loadout',
  'library.tactics.pdf.noTask',
  'library.tactics.pdf.out',
  'library.tactics.pdf.page',
  'library.tactics.pdf.plans',
  'library.tactics.pdf.startsAt',
  'library.tactics.pdf.tasks',
  'library.tactics.pdf.teamCost',
  'library.tactics.preview.label',
  'library.tactics.preview.startsAt',
  'library.tactics.preview.throws',
  'library.tactics.transfer.another',
  'library.tactics.transfer.close',
  'library.tactics.transfer.conflictHint',
  'library.tactics.transfer.conflictTitle',
  'library.tactics.transfer.done',
  'library.tactics.transfer.doneNone',
  'library.tactics.transfer.downloadLibrary',
  'library.tactics.transfer.downloadOne',
  'library.tactics.transfer.dropActive',
  'library.tactics.transfer.dropHint',
  'library.tactics.transfer.dropTitle',
  'library.tactics.transfer.exportNote',
  'library.tactics.transfer.failed',
  'library.tactics.transfer.footer',
  'library.tactics.transfer.importAction',
  'library.tactics.transfer.importNote',
  'library.tactics.transfer.incoming',
  'library.tactics.transfer.keepAll',
  'library.tactics.transfer.open',
  'library.tactics.transfer.scopeLabel',
  'library.tactics.transfer.scopeLibrary',
  'library.tactics.transfer.scopeLibraryMeta',
  'library.tactics.transfer.scopeOne',
  'library.tactics.transfer.scopeOneMeta',
  'library.tactics.transfer.tabExport',
  'library.tactics.transfer.tabImport',
  'library.tactics.transfer.tabsLabel',
  'library.tactics.transfer.title',
  'library.tactics.transfer.unchanged',
  'library.tactics.transfer.version',
  'library.tactics.transfer.yours',
  'library.tactics.untitled',
  'library.tactics.zoom.in',
  'library.tactics.zoom.level',
  'library.tactics.zoom.out',
  'library.tools.economy.assumptionCount',
  'library.tools.economy.assumptions.genericKillReward',
  'library.tools.economy.assumptions.otherUnpriced',
  'library.tools.economy.assumptions.survivorCarry',
  'library.tools.economy.assumptions.unknownKills',
  'library.tools.economy.assumptions.unknownPlant',
  'library.tools.economy.assumptions.unknownSurvivors',
  'library.tools.economy.assumptions.unknownWeapons',
  'library.tools.economy.assumptions.unpricedEquipment',
  'library.tools.economy.bombDefused',
  'library.tools.economy.bombExploded',
  'library.tools.economy.bombPlanted',
  'library.tools.economy.cancelEdit',
  'library.tools.economy.cancelReset',
  'library.tools.economy.clearRounds',
  'library.tools.economy.confirmNewMatch',
  'library.tools.economy.decreaseWeapon',
  'library.tools.economy.editRound',
  'library.tools.economy.elimination',
  'library.tools.economy.emptyHint',
  'library.tools.economy.emptyTitle',
  'library.tools.economy.enemyKills',
  'library.tools.economy.enteringNow',
  'library.tools.economy.history',
  'library.tools.economy.increaseWeapon',
  'library.tools.economy.known',
  'library.tools.economy.lossShort',
  'library.tools.economy.lossStreak',
  'library.tools.economy.lost',
  'library.tools.economy.modelNote',
  'library.tools.economy.newMatch',
  'library.tools.economy.nextRound',
  'library.tools.economy.no',
  'library.tools.economy.now',
  'library.tools.economy.observedSpend',
  'library.tools.economy.opponent',
  'library.tools.economy.otherWeapon',
  'library.tools.economy.perPlayer',
  'library.tools.economy.reason',
  'library.tools.economy.removeRound',
  'library.tools.economy.result',
  'library.tools.economy.round',
  'library.tools.economy.roundIncome',
  'library.tools.economy.roundShort',
  'library.tools.economy.save',
  'library.tools.economy.scale.eco',
  'library.tools.economy.scale.force',
  'library.tools.economy.scale.full',
  'library.tools.economy.startSide',
  'library.tools.economy.streakRounds',
  'library.tools.economy.survivors',
  'library.tools.economy.timeExpired',
  'library.tools.economy.title',
  'library.tools.economy.unknown',
  'library.tools.economy.verdict.eco',
  'library.tools.economy.verdict.ecoOrForce',
  'library.tools.economy.verdict.force',
  'library.tools.economy.verdict.forceOrFull',
  'library.tools.economy.verdict.full',
  'library.tools.economy.verdict.unclear',
  'library.tools.economy.weaponPistol',
  'library.tools.economy.weaponShotgun',
  'library.tools.economy.weaponSmg',
  'library.tools.economy.weaponsTitle',
  'library.tools.economy.winShort',
  'library.tools.economy.won',
  'library.tools.economy.yes',
  'library.tools.grenades.axisLabel',
  'library.tools.grenades.axisSeconds',
  'library.tools.grenades.chartHint',
  'library.tools.grenades.chartInstant',
  'library.tools.grenades.chartTitle',
  'library.tools.grenades.damage',
  'library.tools.grenades.damageBlind',
  'library.tools.grenades.damageDecoy',
  'library.tools.grenades.damageExplosive',
  'library.tools.grenades.damageFire',
  'library.tools.grenades.damageNone',
  'library.tools.grenades.instant',
  'library.tools.grenades.lasts',
  'library.tools.grenades.los',
  'library.tools.grenades.note',
  'library.tools.grenades.reach',
  'library.tools.grenades.seconds',
  'library.tools.grenades.sideBoth',
  'library.tools.grenades.sideCt',
  'library.tools.grenades.sideT',
  'library.tools.grenades.sightShort',
  'library.tools.grenades.title',
  'library.tools.grenades.units',
  'library.tools.grenades.unitsShort',
  'library.tools.hero',
  'library.tools.note',
  'library.tools.tabs.economy',
  'library.tools.tabs.grenades',
  'library.tools.tabs.weapons',
  'library.tools.title',
  'library.tools.weapons.categories.all',
  'library.tools.weapons.categories.equipment',
  'library.tools.weapons.categories.machinegun',
  'library.tools.weapons.categories.pistol',
  'library.tools.weapons.categories.rifle',
  'library.tools.weapons.categories.shotgun',
  'library.tools.weapons.categories.smg',
  'library.tools.weapons.categories.sniper',
  'library.tools.weapons.columns.chest',
  'library.tools.weapons.columns.head',
  'library.tools.weapons.columns.killReward',
  'library.tools.weapons.columns.legs',
  'library.tools.weapons.columns.price',
  'library.tools.weapons.columns.rpm',
  'library.tools.weapons.columns.stomach',
  'library.tools.weapons.columns.weapon',
  'library.tools.weapons.detail.killReward',
  'library.tools.weapons.detail.noteBasis',
  'library.tools.weapons.detail.noteNone',
  'library.tools.weapons.detail.notePellets',
  'library.tools.weapons.detail.noteVest',
  'library.tools.weapons.detail.noteVestHelmet',
  'library.tools.weapons.detail.pellets',
  'library.tools.weapons.detail.penetration',
  'library.tools.weapons.detail.price',
  'library.tools.weapons.detail.rpm',
  'library.tools.weapons.detail.shots',
  'library.tools.weapons.detail.zones.chest',
  'library.tools.weapons.detail.zones.head',
  'library.tools.weapons.detail.zones.legs',
  'library.tools.weapons.detail.zones.stomach',
  'library.tools.weapons.empty',
  'library.tools.weapons.groups.armour',
  'library.tools.weapons.groups.category',
  'library.tools.weapons.groups.side',
  'library.tools.weapons.mode.none',
  'library.tools.weapons.mode.vest',
  'library.tools.weapons.mode.vestHelmet',
  'library.tools.weapons.note',
  'library.tools.weapons.searchPlaceholder',
  'library.tools.weapons.sides.all',
  'library.tools.weapons.sides.any',
  'library.tools.weapons.sides.ct',
  'library.tools.weapons.sides.only',
  'library.tools.weapons.sides.t',
  'library.tools.weapons.title',
  'radar.coach.color',
  'radar.coach.colors.ct',
  'radar.coach.colors.damage',
  'radar.coach.colors.ink',
  'radar.coach.colors.objective',
  'radar.coach.colors.t',
  'radar.coach.label',
  'radar.coach.tools.clear',
  'radar.coach.tools.deleteNote',
  'radar.coach.tools.eraser',
  'radar.coach.tools.flash',
  'radar.coach.tools.he',
  'radar.coach.tools.molotov',
  'radar.coach.tools.move',
  'radar.coach.tools.pencil',
  'radar.coach.tools.redo',
  'radar.coach.tools.saveNote',
  'radar.coach.tools.smoke',
  'radar.coach.tools.undo',
  'radar.debug.altitudeBand',
  'radar.debug.frame',
  'radar.debug.level',
  'radar.debug.map',
  'radar.debug.pointer',
  'radar.debug.pointerHint',
  'radar.debug.pointerValue',
  'radar.floor.lower',
  'radar.floor.upper',
  'radar.imageUnavailable',
  'radar.label',
  'radar.targetLegend.landed',
  'radar.targetLegend.origin',
  'radar.targetLegend.path',
  'radar.title',
  'radar.unknownMap.hint',
  'radar.unknownMap.title',
  'radar.utility.secondsUnit',
  'review.board.assists',
  'review.board.player',
  'review.board.started',
  'review.bombClock',
  'review.close',
  'review.duels.grid.cell',
  'review.duels.grid.hint',
  'review.duels.grid.team',
  'review.duels.grid.title',
  'review.duels.legend.colour',
  'review.duels.legend.killer',
  'review.duels.legend.victim',
  'review.duels.list.pair',
  'review.duels.list.player',
  'review.duels.list.select',
  'review.duels.list.title',
  'review.duels.mode.all',
  'review.duels.mode.label',
  'review.duels.mode.openings',
  'review.duels.panel.duel.headshot',
  'review.duels.panel.duel.kind',
  'review.duels.panel.duel.kindOpening',
  'review.duels.panel.duel.text',
  'review.duels.panel.duel.watch',
  'review.duels.panel.label',
  'review.duels.panel.overview.all',
  'review.duels.panel.overview.allText',
  'review.duels.panel.overview.openings',
  'review.duels.panel.overview.openingsText',
  'review.duels.panel.overview.team',
  'review.duels.panel.overview.topDeaths',
  'review.duels.panel.overview.topFirstDeaths',
  'review.duels.panel.overview.topKills',
  'review.duels.panel.overview.topOpeners',
  'review.duels.panel.pair.even',
  'review.duels.panel.pair.killed',
  'review.duels.panel.pair.kind',
  'review.duels.panel.pair.leader',
  'review.duels.panel.pair.weapons',
  'review.duels.panel.player.deaths',
  'review.duels.panel.player.diedTo',
  'review.duels.panel.player.kills',
  'review.duels.panel.player.killsBySide',
  'review.duels.panel.player.kindAll',
  'review.duels.panel.player.kindOpenings',
  'review.duels.panel.player.mostKilled',
  'review.duels.panel.player.text',
  'review.duels.panel.player.weapons',
  'review.duels.panel.player.won',
  'review.duels.panel.times',
  'review.duels.reset',
  'review.equipment',
  'review.feed.label',
  'review.feed.unknownPlayer',
  'review.fullscreen.enter',
  'review.fullscreen.exit',
  'review.heat.buy.all',
  'review.heat.buy.eco',
  'review.heat.buy.force',
  'review.heat.buy.full',
  'review.heat.buy.label',
  'review.heat.buy.pistol',
  'review.heat.compare.cancel',
  'review.heat.compare.change',
  'review.heat.compare.close',
  'review.heat.compare.confirm',
  'review.heat.compare.libraryMatch',
  'review.heat.compare.matchStep',
  'review.heat.compare.meta',
  'review.heat.compare.missing',
  'review.heat.compare.noPlayers',
  'review.heat.compare.note',
  'review.heat.compare.otherMap',
  'review.heat.compare.playerStep',
  'review.heat.compare.reading',
  'review.heat.compare.remove',
  'review.heat.compare.start',
  'review.heat.compare.startHint',
  'review.heat.compare.teams',
  'review.heat.compare.thisMatch',
  'review.heat.compare.thisMatchRow',
  'review.heat.compare.title',
  'review.heat.damage',
  'review.heat.deaths',
  'review.heat.filters.buy',
  'review.heat.filters.side',
  'review.heat.filters.time',
  'review.heat.filters.whole',
  'review.heat.kills',
  'review.heat.layer',
  'review.heat.legend.difference',
  'review.heat.legend.events',
  'review.heat.legend.field',
  'review.heat.legend.overlay',
  'review.heat.legend.pair',
  'review.heat.legend.rings',
  'review.heat.legend.utility',
  'review.heat.more',
  'review.heat.moreNote',
  'review.heat.other.damageDealt',
  'review.heat.other.damageTaken',
  'review.heat.other.kills',
  'review.heat.other.utility',
  'review.heat.overlap',
  'review.heat.panel',
  'review.heat.player',
  'review.heat.playerA',
  'review.heat.playerB',
  'review.heat.read.died',
  'review.heat.read.stood',
  'review.heat.team',
  'review.heat.throws',
  'review.heat.title.died',
  'review.heat.title.difference',
  'review.heat.title.other',
  'review.heat.title.pair',
  'review.heat.title.stood',
  'review.heat.views.difference',
  'review.heat.views.label',
  'review.heat.views.overlay',
  'review.heat.views.side',
  'review.heat.when.alive',
  'review.heat.when.bar',
  'review.heat.when.detail',
  'review.heat.when.detailHide',
  'review.heat.when.detailShow',
  'review.heat.when.hint',
  'review.heat.when.pending',
  'review.heat.when.phase.end',
  'review.heat.when.phase.middle',
  'review.heat.when.phase.start',
  'review.heat.when.phaseRange',
  'review.heat.when.phaseRangeOpen',
  'review.heat.when.pick',
  'review.heat.when.play',
  'review.heat.when.playLabel',
  'review.heat.when.range',
  'review.heat.when.rangeToEnd',
  'review.heat.when.stop',
  'review.heat.when.title',
  'review.heat.when.whole',
  'review.heat.when.wholeRange',
  'review.lineups.close',
  'review.lineups.empty.lead',
  'review.lineups.empty.repeated',
  'review.lineups.empty.spots',
  'review.lineups.empty.step1',
  'review.lineups.empty.step2',
  'review.lineups.empty.step3',
  'review.lineups.empty.title',
  'review.lineups.empty.top',
  'review.lineups.howTo.approximate',
  'review.lineups.howTo.console',
  'review.lineups.howTo.copied',
  'review.lineups.howTo.copy',
  'review.lineups.howTo.stand',
  'review.lineups.howTo.throw',
  'review.lineups.howTo.title',
  'review.lineups.keys.jump',
  'review.lineups.listTitle',
  'review.lineups.myLineups',
  'review.lineups.noMatches',
  'review.lineups.onTheMove',
  'review.lineups.onTheMoveNote',
  'review.lineups.originAria',
  'review.lineups.origins',
  'review.lineups.panel',
  'review.lineups.playersMore',
  'review.lineups.replay.chip',
  'review.lineups.replay.title',
  'review.lineups.replay.watch',
  'review.lineups.resetFilters',
  'review.lineups.rowMeta',
  'review.lineups.save.action',
  'review.lineups.save.edit',
  'review.lineups.save.failed',
  'review.lineups.save.hint',
  'review.lineups.save.saved',
  'review.lineups.save.title',
  'review.lineups.save.undo',
  'review.lineups.search',
  'review.lineups.searchHint',
  'review.lineups.stack.aria',
  'review.lineups.stack.title',
  'review.lineups.targetAria',
  'review.lineups.targetMeta',
  'review.lineups.throws',
  'review.lineups.unnamed',
  'review.lineups.variantMeta',
  'review.map',
  'review.maps.bothSides',
  'review.maps.controls',
  'review.maps.duelList',
  'review.maps.everyKind',
  'review.maps.everyone',
  'review.maps.kinds',
  'review.maps.minutes',
  'review.maps.players',
  'review.maps.roundShort',
  'review.maps.rowLabel',
  'review.maps.sides',
  'review.maps.throw.types.crouch',
  'review.maps.throw.types.jump',
  'review.maps.throw.types.run',
  'review.maps.throw.types.stand',
  'review.maps.throw.types.unknown',
  'review.maps.worldKillNote',
  'review.metrics.clutches.note',
  'review.metrics.clutches.title',
  'review.metrics.empty',
  'review.metrics.enemyBlindTime.note',
  'review.metrics.enemyBlindTime.title',
  'review.metrics.multi.note',
  'review.metrics.multi.title',
  'review.metrics.opening.note',
  'review.metrics.opening.title',
  'review.metrics.trades.note',
  'review.metrics.trades.title',
  'review.metrics.utilityDamage.note',
  'review.metrics.utilityDamage.title',
  'review.player.armour',
  'review.player.damage',
  'review.player.dead',
  'review.player.deaths',
  'review.player.empty',
  'review.player.equipment',
  'review.player.health',
  'review.player.helmet',
  'review.player.kills',
  'review.player.money',
  'review.roundClock',
  'review.score',
  'review.scoreboard',
  'review.stats.best.adr',
  'review.stats.best.kast',
  'review.stats.best.kills',
  'review.stats.best.openingKills',
  'review.stats.best.rating',
  'review.stats.best.title',
  'review.stats.best.utilityDamage',
  'review.stats.buy.name.eco',
  'review.stats.buy.name.force',
  'review.stats.buy.name.full',
  'review.stats.buy.name.mixed',
  'review.stats.buy.name.pistol',
  'review.stats.buy.short.eco',
  'review.stats.buy.short.force',
  'review.stats.buy.short.full',
  'review.stats.buy.short.mixed',
  'review.stats.buy.short.pistol',
  'review.stats.history.buy',
  'review.stats.history.legend',
  'review.stats.history.roundDraw',
  'review.stats.history.roundWon',
  'review.stats.history.title',
  'review.stats.line.buys',
  'review.stats.line.round',
  'review.stats.line.topKiller',
  'review.stats.line.watch',
  'review.stats.line.won',
  'review.stats.nav',
  'review.stats.noFlashEvents',
  'review.stats.players.col.adr',
  'review.stats.players.col.blind',
  'review.stats.players.col.clutches',
  'review.stats.players.col.deathsTraded',
  'review.stats.players.col.diff',
  'review.stats.players.col.diffName',
  'review.stats.players.col.flashAssists',
  'review.stats.players.col.headshots',
  'review.stats.players.col.kast',
  'review.stats.players.col.multi',
  'review.stats.players.col.multiName',
  'review.stats.players.col.openingDeaths',
  'review.stats.players.col.openingKills',
  'review.stats.players.col.openingSuccess',
  'review.stats.players.col.rating',
  'review.stats.players.col.tradeKills',
  'review.stats.players.col.utilityDamage',
  'review.stats.players.detail.chipClutch',
  'review.stats.players.detail.chipMulti',
  'review.stats.players.detail.duels',
  'review.stats.players.detail.keyRounds',
  'review.stats.players.detail.multi',
  'review.stats.players.detail.noKeyRounds',
  'review.stats.players.detail.opening',
  'review.stats.players.notes.flash',
  'review.stats.players.notes.kast',
  'review.stats.players.notes.multi',
  'review.stats.players.notes.opening',
  'review.stats.players.notes.rating',
  'review.stats.players.notes.title',
  'review.stats.players.notes.trade',
  'review.stats.players.setNotes.duels',
  'review.stats.players.setNotes.main',
  'review.stats.players.setNotes.multi',
  'review.stats.players.setNotes.utility',
  'review.stats.players.sets.duels',
  'review.stats.players.sets.main',
  'review.stats.players.sets.multi',
  'review.stats.players.sets.utility',
  'review.stats.players.setsLabel',
  'review.stats.players.short.assists',
  'review.stats.players.short.deaths',
  'review.stats.players.short.kills',
  'review.stats.players.title',
  'review.stats.reason.allCtEliminated',
  'review.stats.reason.allTEliminated',
  'review.stats.reason.bombDefused',
  'review.stats.reason.bombExploded',
  'review.stats.reason.draw',
  'review.stats.reason.timeExpired',
  'review.stats.rounds.all',
  'review.stats.rounds.fig.antiEco',
  'review.stats.rounds.fig.eco',
  'review.stats.rounds.fig.firstKillConceded',
  'review.stats.rounds.fig.firstKillGot',
  'review.stats.rounds.fig.fiveVsFour',
  'review.stats.rounds.fig.force',
  'review.stats.rounds.fig.fourVsFive',
  'review.stats.rounds.fig.full',
  'review.stats.rounds.fig.pistol',
  'review.stats.rounds.fig.plants',
  'review.stats.rounds.fig.postPlant',
  'review.stats.rounds.fig.retakes',
  'review.stats.rounds.none',
  'review.stats.rounds.notes.antiEco',
  'review.stats.rounds.notes.bomb',
  'review.stats.rounds.notes.buy',
  'review.stats.rounds.notes.firstKill',
  'review.stats.rounds.notes.manAdvantage',
  'review.stats.rounds.notes.pistol',
  'review.stats.rounds.notes.split',
  'review.stats.summary.halves',
  'review.stats.summary.halvesOvertime',
  'review.stats.summary.title',
  'review.stats.summary.winner',
  'review.stats.tabs.players',
  'review.stats.tabs.rounds',
  'review.stats.tabs.utility',
  'review.stats.unknown',
  'review.stats.utility.col.averageBlind',
  'review.stats.utility.col.damagePerRound',
  'review.stats.utility.col.enemiesPerFlash',
  'review.stats.utility.col.flashesThrown',
  'review.stats.utility.col.teamFlashes',
  'review.stats.utility.col.total',
  'review.stats.utility.col.unusedDollars',
  'review.stats.utility.col.unusedGrenades',
  'review.stats.utility.noFlashEvents',
  'review.stats.utility.notes.damage',
  'review.stats.utility.notes.flashes',
  'review.stats.utility.notes.thrown',
  'review.stats.utility.notes.unused',
  'review.stats.utility.table.damage',
  'review.stats.utility.table.flashes',
  'review.stats.utility.table.thrown',
  'review.stats.utility.team',
  'review.tactics.coordination.coordinated',
  'review.tactics.coordination.hint',
  'review.tactics.coordination.loose',
  'review.tactics.coordination.none',
  'review.tactics.coordination.partial',
  'review.tactics.coordination.signal.grouped',
  'review.tactics.coordination.signal.plant',
  'review.tactics.coordination.signal.trade',
  'review.tactics.coordination.signal.utilityBurst',
  'review.tactics.detail.label',
  'review.tactics.filter.ct',
  'review.tactics.filter.label',
  'review.tactics.filter.lost',
  'review.tactics.filter.planted',
  'review.tactics.filter.t',
  'review.tactics.filter.won',
  'review.tactics.list.empty',
  'review.tactics.list.label',
  'review.tactics.opponents.label',
  'review.tactics.pill',
  'review.tactics.row.lost',
  'review.tactics.row.noPlant',
  'review.tactics.row.planted',
  'review.tactics.row.site',
  'review.tactics.row.won',
  'review.tactics.save.action',
  'review.tactics.save.failed',
  'review.tactics.save.hint',
  'review.tactics.save.open',
  'review.tactics.save.saved',
  'review.tactics.save.undo',
  'review.tactics.step.contact',
  'review.tactics.step.defence',
  'review.tactics.step.numbered',
  'review.tactics.step.opening',
  'review.tactics.step.retake',
  'review.tactics.step.utility',
  'review.tactics.team.label',
  'review.tactics.title',
  'review.tactics.window.cut',
  'review.tactics.window.end',
  'review.tactics.window.hint',
  'review.tactics.window.label',
  'review.tactics.window.plant',
  'review.tactics.window.range',
  'review.tactics.window.start',
  'review.team',
  'review.views.analysis',
  'review.views.duels',
  'review.views.heatmap',
  'review.views.loading',
  'review.views.more',
  'review.views.nav',
  'review.views.stage',
  'review.views.stats',
  'review.views.tactics',
  'review.views.utility',
  'settings.audibility.label',
  'settings.audibility.note',
  'settings.debug.label',
  'settings.debug.note',
  'settings.dismiss',
  'settings.group.colour',
  'settings.group.developer',
  'settings.group.interface',
  'settings.group.plate',
  'settings.group.playback',
  'settings.group.spectator',
  'settings.heldArrowRate.label',
  'settings.heldArrowRate.note',
  'settings.heldArrowRate.option',
  'settings.language.en',
  'settings.language.label',
  'settings.language.note',
  'settings.language.ru',
  'settings.language.system',
  'settings.look.cyber',
  'settings.look.default',
  'settings.look.label',
  'settings.look.note',
  'settings.motion.full',
  'settings.motion.label',
  'settings.motion.note',
  'settings.motion.reduced',
  'settings.motion.system',
  'settings.palette.colour-blind',
  'settings.palette.cyber',
  'settings.palette.default',
  'settings.palette.label',
  'settings.palette.note',
  'settings.playerNames.label',
  'settings.playerNames.note',
  'settings.radarTheme.blue',
  'settings.radarTheme.cyber',
  'settings.radarTheme.label',
  'settings.radarTheme.note',
  'settings.radarTheme.vanilla',
  'settings.scoreboard.block',
  'settings.scoreboard.label',
  'settings.scoreboard.note',
  'settings.scoreboard.plate',
  'settings.seekStep.label',
  'settings.seekStep.note',
  'settings.seekStep.option',
  'settings.skipBuyPhase.label',
  'settings.skipBuyPhase.note',
  'settings.spectatorCrosshair.label',
  'settings.spectatorCrosshair.note',
  'settings.spectatorKeys.label',
  'settings.spectatorKeys.note',
  'settings.survivors.label',
  'settings.survivors.note',
  'settings.title',
  'settings.trajectories.flight',
  'settings.trajectories.label',
  'settings.trajectories.note',
  'settings.trajectories.off',
  'settings.trajectories.selected',
  'timeline.economy.even',
  'timeline.economy.label',
  'timeline.economy.lead',
  'timeline.events',
  'timeline.match.caption',
  'timeline.match.dismiss',
  'timeline.match.legend.density',
  'timeline.match.legend.economy',
  'timeline.match.legend.kills',
  'timeline.match.legend.rounds',
  'timeline.match.title',
  'timeline.outcome.allCtEliminated',
  'timeline.outcome.allTEliminated',
  'timeline.outcome.bombDefused',
  'timeline.outcome.bombExploded',
  'timeline.outcome.draw',
  'timeline.outcome.timeExpired',
  'timeline.outcomes',
  'timeline.overview',
  'timeline.positionInRound',
  'timeline.positionInWarmup',
  'timeline.roundLabel',
  'timeline.roundNoted',
  'timeline.survivors.hide',
  'timeline.survivors.show',
  'timeline.unknownPlayer',
] as const;

export type TranslationKey = (typeof TRANSLATION_KEYS)[number];

declare global {
  namespace FormatjsIntl {
    interface Message {
      ids: TranslationKey;
    }
  }
}
